import { NotePage } from '../NotePage/NotePage';
import { FunctionalMedicineParagraphs } from './Paragraphs';

export const FunctionalMedicine = () => (
  <NotePage
    title="Functional medicine and root-cause thinking"
    eyebrow="Wellness note"
    summary="An educational note about looking at symptoms in context: lifestyle, history, patterns, and the conversations that make care more personal."
    paragraphs={FunctionalMedicineParagraphs}
    relatedTitle="Functional Medicine"
    appointmentServiceValue="Functional Medicine"
  />
);
